import { CallbackComponent } from 'redux-oidc';
import userManager from 'src/userManager';
import { useNavigate } from 'react-router-dom';
import { MeRoutesEnum, RoutesEnum } from 'src/shared/models/enums/routes.enum';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { BigLoader } from 'src/shared/components/organisms/bigLoader';
import { useSelector } from 'react-redux';
import { RootState } from 'src/shared/services/store';
import { UserAccountTypeEnum } from 'src/shared/models/enums/userAccountType.enum';

export const Callback = () => {
  const { t } = useTranslation(['common']);
  const navigate = useNavigate();
  const user = useSelector((state: RootState) => state.oidc.user);

  return (
    <>
      {/* @ts-expect-error Server Component */}
      <CallbackComponent
        userManager={userManager}
        successCallback={() => {
          if (user?.profile?.accountType === UserAccountTypeEnum.Member) {
            ConsoleHelper.log('CALLBACK FOR MEMBER');
            navigate(MeRoutesEnum.MemberDashboard);
          } else {
            ConsoleHelper.log('CALLBACK FOR USER');
            navigate(RoutesEnum.Dashboard);
          }
        }}
        errorCallback={(error) => {
          navigate(RoutesEnum.Login);
          ConsoleHelper.error(error);
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '100vw',
            height: '100vh',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: `#fff !important`,
          }}
        >
          <BigLoader message={t('common:statusMessages.redirecting')} />
        </Box>
      </CallbackComponent>
    </>
  );
};
